(function () {
    "use strict";
    angular.module("app.core").directive("ngVisible", [
        function () {
            function link(scope, element, attrs) {
                var elem = element[0];
                var isRun = false;
                const observer = new IntersectionObserver((entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting && !isRun) {
                            scope.$eval(attrs.ngVisible);
                            isRun = true;
                        }
                    });
                });
                observer.observe(elem);
            }
            return {
                link: link,
            };
        },
    ]);
})();
